import HootsuiteContentSourceCallbackPage from './callbackPage'
import Login from './login'
import Logout from './logout'

export default {
  name: 'HootsuiteContentSourceAuth',
  routeProps: {
    path: '/authentication',
  },
  children: [HootsuiteContentSourceCallbackPage, Login, Logout],
}
